import instance from "./instance";
import axios from "axios";
import {
    QUESTIONS_ANSWERED,
    REUSE_RESPONSES,
    SCORE_REUSE_ELIGIBILITY,
    TIMER_VALUE,
} from "./constants";

export const postCall = async (url, data, headers) => {
    return await instance.post(url, data, { headers });
};
export const getCall = async (url, headers) => {
    return await instance.get(url, { headers });
};

export const getNoCacheCall = async (url, headers) => {
    const queryStringDivider = url.indexOf("?") === -1 ? "?" : "&";
    url += queryStringDivider + "noCache=" + new Date().getTime();
    return await instance.get(url, { headers });
};

export const getTestQuestion = async (idTest, sessionId, idPage) => {
    return await axios.get(`/rest/tt/questionp/${idTest}/${idPage}`, {
        headers: {
            "x-xpert-session": sessionId,
            "Content-Type": "application/json",
        },
    });
};

export const saveAnswers = async (
    answerData,
    duration,
    testId,
    sessionId,
    keyStroke
) => {
    return await axios.post(
        `/rest/tt/saveDataEntryTest/`,
        {
            answers: answerData,
            duration: duration,
            keystrikes: keyStroke,
        },
        {
            headers: {
                test_id: testId,
                "x-xpert-session": sessionId,
                "Content-Type": "application/json",
            },
        }
    );
};

export const fetchQuestionTest28 = async (testId, sessionId) => {
    return await axios.post(
        "/rest/tt/getDataEntryTest",
        {},
        {
            headers: {
                test_id: testId,
                "x-xpert-session": sessionId,
                "Content-Type": "application/json",
            },
        }
    );
};

export const getFocusAndMultitaskingTest = async (
    testId,
    sessionId,
    fromExample
) => {
    return await axios.post(
        `/rest/tt/getFocusAndMultitaskingTest/?fromExample=${fromExample}`,
        {},
        {
            headers: {
                test_id: testId,
                "x-xpert-session": sessionId,
                "Content-Type": "application/json",
            },
        }
    );
};

export const getQuestionFM = async (idTest, sessionId, idPage) => {
    return await axios.get(`/rest/tt/questionp/${idTest}/${idPage}`, {
        headers: {
            "x-xpert-session": sessionId,
            "Content-Type": "application/json",
        },
    });
};

export const postAnswerFM = async (idTest, sessionId, payload) => {
    return await axios.post(`/rest/tt/questionp/${idTest}`, payload, {
        headers: {
            "x-xpert-session": sessionId,
            "Content-Type": "application/json",
        },
    });
};

export const saveResulltFM = async (idTest, sessionId, payload) => {
    return await axios.post(`/rest/tt/tresult/${idTest}`, payload, {
        headers: {
            "x-xpert-session": sessionId,
            "Content-Type": "application/json",
        },
    });
};

export const getDecrypt = async (data) => {
    return await axios.get(`/rest/tt/getDecryptedData/`, {
        headers: {
            content: data,
        },
    });
};

export const getNumberOfQuestionAnswered = async (assignmentId, testId) => {
    return await axios.post(QUESTIONS_ANSWERED, {
        assignmentId: assignmentId,
        testId: testId,
    });
};

export const getTimerValue = async () => {
    return await axios.get(TIMER_VALUE);
};
export const getReuseEligibilityDetails = (candidateId, instrumentIds) => {
    return axios.post(SCORE_REUSE_ELIGIBILITY + candidateId, instrumentIds);
};

export const reuseAssessmentResponses = (testDetailsForReuse) => {
    return axios.post(REUSE_RESPONSES, {
        ...testDetailsForReuse,
    });
};
